import { JsonConverter, JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo } from "../base-types";
import { MemberConditionResourceConverter } from "../converters/member-condition-resource-converter";
import { MemberConditionResource } from "./member-condition-resource";
import { MemberDefinitionResource } from "./member-definition-resource";

@JsonObject()
export class MemberGroupResource {
    @JsonProperty("name")
    name: string;

    @JsonProperty("content_group")
    contentGroup: string;

    @JsonProperty("is_system_owned")
    isSystemOwned: boolean;

    @JsonProperty("is_conditional")
    isConditional: boolean;

    @JsonProperty("conditions")
    @JsonElementType(MemberConditionResource)
    @JsonConverter(MemberConditionResourceConverter)
    conditions: Array<MemberConditionResource>;

    @JsonProperty("is_secured")
    isSecured: boolean;

    @JsonProperty("members")
    @JsonElementType(MemberDefinitionResource)
    memberDefinitions: Array<MemberDefinitionResource>;

    @JsonProperty("labels")
    labels: MapCultureTo<string>;

    constructor(init?: Partial<MemberGroupResource>) {
        Object.assign(this, init);
    }
}
